export default __webpack_public_path__ + "static/media/M2_test.b277ac2c.png";